// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import { Outlet } from 'react-router-dom';
import { RequirePermission } from 'components/auth/RequirePermission';
import { breadcrumbTranslation } from 'components/layout/Breadcrumb/utils';

export const alertsRoutes = [
  {
    path: 'alerts',
    breadcrumb: breadcrumbTranslation('alerts'),
    element: (
      <RequirePermission permission="alert:read" redirectTo="/">
        <Outlet />
      </RequirePermission>
    ),
    children: [
      {
        index: true,
        lazy: () => import('pages/Alerts'),
      },
    ],
  },
];
